import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-request-form-receipts',
  templateUrl: './request-form-receipts.component.html'
})
export class RequestFormReceiptsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
